import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { DELETE_DAYCARE_MEAL_ACCESSIBILITY } from '@/modules/API/meal/daycareSettingsHandler.ts'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { useMutation } from '@apollo/client'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import styles from '../../meal.module.scss'
import { MealAccessibilitySection } from '@/types/Meal.ts'
import { Delete } from '@mui/icons-material'
import Close from '@mui/icons-material/Close'
import moment from 'moment-timezone'

interface DeleteMealAccessibilityDialogProps {
    open: boolean
    handleClose: () => void
    refetch: () => void
    daycareId: number
    accessibilitySection: MealAccessibilitySection
}

const DeleteMealAccessibilityDialog: FunctionComponent<DeleteMealAccessibilityDialogProps> = ({
    open,
    handleClose,
    refetch,
    daycareId,
    accessibilitySection
}: DeleteMealAccessibilityDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteMealAccessibility] = useMutation(DELETE_DAYCARE_MEAL_ACCESSIBILITY, {
        variables: {
            daycareId,
            accessibilitySectionId: accessibilitySection.id,
            sectionId: accessibilitySection.sectionId
        },
        onCompleted: () => {
            refetch()
            handleClose()

            showNotificationSuccess(t('mealAccessibilityDeleted'))
        },
        onError: () => {
            handleClose()

            showNotificationError(t('mealAccessibilityDeletedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('deleteMealAccessibility')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextContainer}>
                    <p className={styles.Text}>{t('confirmDeleteMealAccessibility')}</p>
                    <p className={styles.TextAccessibility}>
                        {accessibilitySection.sectionName} {t('to').toLowerCase()}{' '}
                        {moment(accessibilitySection.start, 'HH:mm:ss').format('HH:mm')}
                    </p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteMealAccessibility}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DeleteMealAccessibilityDialog
